/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import { Text } from "components/text";
import page from "page";

/**
 * Internal dependencies
 */
import Icon from "components/icon";

const Item = ({ children, onClick, path, icon, label }) => {
  const handleOnClick = () => {
    if (path) {
      page(path);
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <Box
      className="user-menu-dropdown__item"
      display="flex"
      width="full"
      padding="medium"
      component={onClick || path ? "button" : "div"}
      onClick={handleOnClick}
    >
      <Box display="flex" alignItems="center">
        {icon && <Icon name={icon} />}
        {label && (
          <Box marginLeft="medium">
            <Text variant="headingXxs">{label}</Text>
          </Box>
        )}
      </Box>
      {children && <Box>{children}</Box>}
    </Box>
  );
};

export default Item;
